import React from "react";

import useTranslation from "next-translate/useTranslation";

import { Button } from "./styles";

interface IButtonLoadMore {
  isLoading: boolean;
  small?: boolean;
  onLoad: () => void;
}

const ButtonLoadMore = ({
  isLoading,
  onLoad,
  small,
  ...rest
}: IButtonLoadMore) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      onClick={onLoad}
      small={small}
      {...rest}
      className="load-more-btn"
    >
      {isLoading ? (
        <>
          <div className="loading" />
          {t("common:loading")}
        </>
      ) : (
        <>{t("common:loadMore")}</>
      )}
    </Button>
  );
};

ButtonLoadMore.defaultProps = {
  isLoading: false,
  small: false,
  onLoad: () => "",
};

export default ButtonLoadMore;
